// Others
import axiosClient from './axiosClient';
import { urlApiLinxUp } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IQueryParamTruckLocation, ITruckLocations } from '~/utils/interface/linxUp';

const linxUpApi = {
  getListTruckLocations: (params: IQueryParamTruckLocation) => {
    const url = urlApiLinxUp.getListTruckLocation;
    return axiosClient.get<IBaseResponse<ITruckLocations[]>>(url, { params });
  },
};

export default linxUpApi;
